import { getHelpCenterRequestEndpoint } from '../constants/endpoints';
import { APIHelpRequest } from '../types/api';
import { httpMethod } from '../utils/sra';

export const coreHelpCenterSendSupportRequest = (
  providerId: string,
  request: APIHelpRequest,
) => ({
  name: 'sendSupportRequest',
  url: getHelpCenterRequestEndpoint(providerId),
  method: httpMethod.post,
  body: request,
});
